module.exports = __webpack_public_path__ + "img/ic_google_original.aba1ec06.svg";